import { ApplicationState, AppThunkDispatch } from "../store";
import { connect } from "react-redux";
import { getChangingState, getChangingValue, isSubmittingNew } from "../store/entities/selectors";
import { createEntity, entityCreatingCancel, updateChangingEntity } from "../store/entities/actions";
import { PackSettings } from "../models";
import ClientPackForm, { ClientPackFormDispatchProps, ClientPackFormStateProps } from "../components/Forms/ClientPackForm";
import { ClientPackEntity } from "../store/entities/state";
import { createClientPackAsync } from "../ajax/requests";
import { canSeePrices, isAdministrator } from "../store/session/selectors";

interface ClientPackCreateFormOwnProps {
    packSettings?: PackSettings,
}

const mapStateToProps = (state: ApplicationState, props: ClientPackCreateFormOwnProps): ClientPackFormStateProps => ({
    type: 'create',
    clientPack: getChangingValue(state, 'clientPacks') as ClientPackEntity,
    packSettings: props.packSettings,
    hasChanged: getChangingState(state, 'clientPacks'),
    canSeePrices: canSeePrices(state),
    isAdministrator: isAdministrator(state),
    loading: isSubmittingNew(state, 'clientPacks'),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch): ClientPackFormDispatchProps => ({
    onChange: (data: ClientPackEntity) => dispatch(updateChangingEntity('clientPacks', data)),
    onClose: () => dispatch(entityCreatingCancel('clientPacks')),
    onSubmit: (data: ClientPackEntity) => dispatch(createEntity('clientPacks', data, c => createClientPackAsync(c))),
});

export default connect<ClientPackFormStateProps, ClientPackFormDispatchProps, ClientPackCreateFormOwnProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ClientPackForm as any);